<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title']
            }),
            new fields.WYSIWYG({
              label: 'Adres',
              modelPath: [this, 'form', 'address'],
              required: true,
              type: 'emptyMenuBarInit'
            }),
            new fields.Input({
              label: 'Telefon',
              required: true,
              modelPath: [this, 'form', 'phone']
            }),
            new fields.Input({
              label: 'Adres e-mail',
              required: true,
              modelPath: [this, 'form', 'email']
            })
          ]
        }
      ]
    }
  }
}
</script>
